
import JSEncrypt from "jsencrypt";
import md5 from 'js-md5';

const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtVOUkB8AeSXBNsfGMjTSTYY8JEc3QQ0AlEdeHfsVbhgUrCdNvGqTkyNt1RQLmB+grplWo7XDgfX3GffpqKeaZZC/S/SvBL4n1EMJF4+kj7IeKeGquDpg8Jxgi8HeNIyB4Q+HhcArmixmZd2QUKYNKOcDojRjk2W0IMN4xrusuSEFfUf2yqiJ6+y6XHaYfXQgBiErwf1PDJjo1Dye2otzCFb9pU9Fr3i3ND7vccw+YaxAYTwd8el13heeCqZ9QEB37RQEKy+F+RgMtqG7p6U138vxo2HDWcM8MXLHrYr/WY3+opixF5cE+JJnBl7tR8n0QfA9XR/dkv+XZF80POJ1lwIDAQAB
-----END PUBLIC KEY-----`;

export default class ProfitHelper {
    static getPostSign(str) {
        const md5Str = md5(str);
        const jse = new JSEncrypt();
        jse.setPublicKey(RSA_PUBLIC_KEY);
        return jse.encrypt(md5Str);
    }
}